






import { Component, Vue, Prop } from 'vue-property-decorator';
import vSelect from 'vue-select';

@Component({
  components: {
    vSelect,
  },
})
export default class FieldTooltip extends Vue {
  @Prop() message: string;
}
